import { UseQueryResult, useQuery } from 'react-query';
import axios, { AxiosError } from 'axios';
import { auth } from '@olo-web/utils/google/firebase';
import admin from '@olo-web/utils/google/firebase/admin';

export const getUserByUid = async ({ uid }): Promise<admin.auth.UserRecord> => {
  try {
    const idToken = await auth().currentUser.getIdToken();
    const { data } = await axios.get(`/api/users/get-by-uid`, {
      params: { idToken, uid },
    });
    return data;
  } catch (error) {
    throw new Error(error?.response?.data?.detail);
  }
};

export const useGetUserByUid = (uid: string): UseQueryResult<admin.auth.UserRecord, AxiosError> => {
  return useQuery(['theme-auth-user', uid], () => getUserByUid({ uid }), {
    staleTime: 100000,
    enabled: !!uid,
    retry: 0,
  });
};
